import { OccupationTitle, OccupationsQuery, OccupationsQueryVariables } from "@ctypes";
import { OCCUPATIONS } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useOccupations = () => {
  const { data: queryData, ...rest } = useQuery<OccupationsQuery, OccupationsQueryVariables>(
    OCCUPATIONS,
  );

  const keys = (() => {
    if (!queryData?.occupations) return [];

    return Object.keys(queryData.occupations);
  })() as Array<OccupationTitle>;

  const values = (() => {
    if (!queryData?.occupations) return [];

    return Object.values(queryData.occupations);
  })() as Array<string>;

  return { keys, values, isEmpty: !queryData?.occupations, ...rest };
};
